'use client';

import dynamic from 'next/dynamic';

// SelectLanguage тянет react-select — вынесен в отдельный файл, чтобы этот
// импорт не оказался в initial-графе (раньше dynamic() ссылался сам на себя
// через import('./index'), и вебпак не мог разбить чанк, потому что этот же
// файл параллельно импортировался синхронно как { SelectLanguageDynamic }).
const SelectLanguageDynamic = dynamic(
  () => import('./select-language').then((m) => m.SelectLanguage),
  {
    ssr: false,
    loading: () => null,
  }
);

export { SelectLanguageDynamic };
